//#region IMPORTS
import { InstoreOrder } from "../../models/instoreOrder";
import { ArchiveBoxIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  archiveHandler: () => void;
  instoreOrder: InstoreOrder;
  hide?: boolean;
}
//#endregion

export default function InstoreOrdersTableRowActionArchive({
  archiveHandler,
  instoreOrder,
  hide = false,
}: Props) {
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Archive order?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(instoreOrder.id) + "archive"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <ArchiveBoxIcon
          className="h-4 w-4 text-purple-700 hover:cursor-pointer hover:text-purple-500"
          onClick={archiveHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreOrder.id) + "archive"} />
    </Fragment>
  ) : null;
}
